<template>
  <v-overlay v-model="visible">
    <div class="modal-warp">
      <div class="modal-body">
        <div v-if="icon" class="modal-icon">
          <img :src="icon" alt="icon" />
        </div>
        <div class="modal-body-content">
          <slot name="header" />
          <div v-if="title" class="modal-title">
            {{ title }}
          </div>
          <div v-if="content" class="modal-content">
            {{ content }}
          </div>
          <slot name="content" />
        </div>
      </div>
      <div class="modal-footer">
        <PubbleButton
          v-if="cancelText"
          :text="cancelText"
          @click="handleCancel"
        />
        <PubbleButton
          v-if="confirmText"
          :text="confirmText"
          type="primary"
          @click="handleConfirm"
        />
        <slot name="footer" />
      </div>
    </div>
  </v-overlay>
</template>

<script>
import PubbleButton from '@/components/PubbleButton.vue'
export default {
  name: 'PebbleModal',
  components: {
    PubbleButton
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleConfirm () {
      this.$emit('confirm')
    },
    handleCancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.modal-warp {
  background: #ffffff;
  padding: 20px;
  width: 400px;
  box-shadow: 0 2px 20px 2px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
}
.modal-body {
  display: flex;
  gap: 8px;
  width: 100%;
}
.modal-body-content {
  width: 100%;
}
.modal-icon {
  width: 16px;
  height: 16px;
  transform: translateY(4px);
}
.modal-title {
  font-family: DiDiSans-Pro-Bold;
  font-size: 16px;
  color: #16161a;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 700;
  margin-bottom: 12px;
}
.modal-content {
  font-family: DiDiSans-Pro-Regular;
  font-size: 14px;
  color: #757580;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 400;
}
.modal-footer {
  margin-top: 12px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
</style>
